import { KEYBOARD_EVENT_COMBINATIONS } from 'config/keyBoardEventsCombinations';
import { KeyboardCombinationType } from 'hooks/useKeydownSubscription';

export const COMBINATIONS: Record<string, KeyboardCombinationType[]> = {
  OPEN_CATALOG_DRAWER: [
    KEYBOARD_EVENT_COMBINATIONS.OPEN_CATALOG_DRAWER.mac,
    KEYBOARD_EVENT_COMBINATIONS.OPEN_CATALOG_DRAWER.windows,
  ],
  ADD_CUSTOM_FIELDS: [
    KEYBOARD_EVENT_COMBINATIONS.ADD_CUSTOM_FIELD.mac,
    KEYBOARD_EVENT_COMBINATIONS.ADD_CUSTOM_FIELD.windows,
  ],
};
